import { Link } from "react-router-dom";
import { FlaskConical, AlertTriangle } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-950 text-slate-400">
      {/* Research-Only Disclaimer */}
      <div data-testid="research-disclaimer" className="border-b border-slate-800/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="bento-card bg-slate-900/50 border-slate-800 p-6 flex items-start gap-4 max-w-4xl" style={{borderRadius: '16px'}}>
            <div className="flex-shrink-0 mt-0.5 w-8 h-8 rounded-lg bg-amber-500/10 flex items-center justify-center">
              <AlertTriangle className="h-4 w-4 text-amber-400" />
            </div>
            <div>
              <p className="text-xs tracking-widest uppercase font-semibold text-amber-400 mb-2">
                For Research Purposes Only
              </p>
              <p className="text-sm leading-relaxed text-slate-400">
                The information presented on RetatrutideGuide.org is intended exclusively for
                educational and scientific research purposes. This content does not constitute
                medical advice, diagnosis, or treatment recommendations. Retatrutide (LY3437943)
                is an investigational compound. Any application of the information herein must
                comply with applicable regulations. Researchers should consult with qualified
                institutional review boards before initiating any research activities.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-sky-400 to-sky-600 flex items-center justify-center">
                <FlaskConical className="h-3.5 w-3.5 text-white" strokeWidth={2} />
              </div>
              <span className="text-[15px] font-bold text-white tracking-tight">
                RetatrutideGuide
              </span>
            </div>
            <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
              The definitive scientific resource for Retatrutide triple-agonist research and clinical data.
            </p>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-xs tracking-widest uppercase font-semibold text-slate-500 mb-4">
              Resources
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" data-testid="footer-link-home" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Master Guide
                </Link>
              </li>
              <li>
                <Link to="/clinical-data" data-testid="footer-link-clinical" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Clinical Trial Data
                </Link>
              </li>
              <li>
                <Link to="/dosage-calc" data-testid="footer-link-dosage" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Dosage Calculator
                </Link>
              </li>
              <li>
                <a href="https://bioinfinity.co/retatrutide/glp3-r" target="_blank" rel="noopener noreferrer" data-testid="footer-link-coa" className="text-sm text-slate-400 hover:text-white transition-colors">
                  Purity & COA (BioInfinity Lab)
                </a>
              </li>
            </ul>
          </div>

          {/* References */}
          <div>
            <h4 className="text-xs tracking-widest uppercase font-semibold text-slate-500 mb-4">
              Key References
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://clinicaltrials.gov" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors">
                  ClinicalTrials.gov
                </a>
              </li>
              <li>
                <a href="https://pubmed.ncbi.nlm.nih.gov" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors">
                  PubMed / NCBI
                </a>
              </li>
              <li>
                <a href="https://www.nejm.org" target="_blank" rel="noopener noreferrer" className="text-sm text-slate-400 hover:text-white transition-colors">
                  NEJM
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-600">
            &copy; {new Date().getFullYear()} RetatrutideGuide.org. All rights reserved.
          </p>
          <p className="text-xs text-slate-600">
            Last scientific review: April 2026
          </p>
        </div>
      </div>
    </footer>
  );
}
